import { Grid, Divider } from "@mui/material";
import sucesso from "../../assets/sucesso.png";
import styled from "@emotion/styled";

function ContratacaoSucesso() {
  
  const Div = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-size: 100%;
  `;

  const Container = styled.div`
    background: #947cfe;
    border-radius: 6px;
    color: #ffffff;
    padding: 2em;
    text-align: center;
    box-shadow: 0px 0px 7px 1px #e5e0e0;
    @media (max-width: 768px) {
      width: 100%;
    }
  `;

  return (
    <Div>
      <Container>
        <h2>Contratação Efetuada com sucesso! </h2>
        <h3 style={{ fontWeight: "normal" }}>
          Baixe o <b>App</b> e aproveite os benefícios e descontos!
        </h3>

        <div style={{ textAlign: "center" }}>
          <img src={sucesso} alt="Contratacao" />
        </div>
      </Container>
    </Div>
  );
}

export default ContratacaoSucesso;
